import type { ReactNode } from 'react';

import {
	hasHistoryDisplayValue,
	isExplicitHistoryEmptyValue,
} from '../util/historyDisplayValue';

import { Empty } from './Empty';

export function renderHistoryDisplayValue(value: ReactNode) {
	if (!hasHistoryDisplayValue(value) || value === '') {
		return <Empty />;
	}

	return isExplicitHistoryEmptyValue(value) ? <Empty /> : value;
}
